export default "__VITE_ASSET__BjbWEhaI__"